import { EmailListType } from "~/types/engage"
import { ITokenInfo } from "~/types/global"
import { IUserFeatureFlags } from "~/types/user"
import { axiosInstance } from "~/utils/axios"

export async function getUser(tokenInfo: ITokenInfo) {
  return await axiosInstance({
    method: "GET",
    url: `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/`,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`
    }
  })
}

export async function getUserFeatureFlags(tokenInfo: ITokenInfo) {
  return await axiosInstance({
    method: "GET",
    url: `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/feature-flags`,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`
    }
  })
}

export async function updateUserFeatureFlags(
  tokenInfo: ITokenInfo,
  payload: IUserFeatureFlags
) {
  return await axiosInstance({
    method: "POST",
    url: `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/feature-flags`,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`
    },
    data: payload
  })
}

export async function updateUsername(
  tokenInfo: ITokenInfo,
  params: { fname: string; sname: string }
) {
  return await axiosInstance({
    method: "PUT",
    url: `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/username`,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`
    },
    data: params
  })
}

export async function updatePassword(
  tokenInfo: ITokenInfo,
  params: { current_password: string; new_password: string }
) {
  return await axiosInstance({
    method: "PUT",
    url: `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/password`,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`
    },
    data: params
  })
}

export async function checkEmailConnection(tokenInfo: ITokenInfo) {
  return await axiosInstance({
    method: "GET",
    url: `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/communications/email/connection-status`,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`
    }
  })
}

export async function getSentEmails(
  tokenInfo: ITokenInfo,
  type: EmailListType
) {
  let url = `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/communications/email/history`
  if (type) {
    url = `${url}?email_type=${type}`
  }
  return await axiosInstance({
    method: "GET",
    url,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`
    }
  })
}

export async function disconnectEmailConnection(
  tokenInfo: ITokenInfo,
  provider: string
) {
  return await axiosInstance({
    method: "POST",
    url: `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/oauth/disconnect`,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`
    },
    data: {
      provider
    }
  })
}

export async function closeWhatsNew(tokenInfo: ITokenInfo) {
  return await axiosInstance({
    method: "POST",
    url: `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/whats-new/`,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`
    }
  })
}

export async function submitNPSSurvey(tokenInfo: ITokenInfo) {
  return await axiosInstance({
    method: "POST",
    url: `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/survey-response/`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${tokenInfo?.token}`
    }
  })
}

export async function getG2StateToken({
  tokenInfo,
  userEmail
}: {
  tokenInfo?: ITokenInfo
  userEmail: string
}) {
  return await axiosInstance({
    method: "GET",
    url: `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/g2/state-token`,
    params: {
      userEmail
    },
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`
    }
  })
}
